
import Vue from 'vue'
import EMAIl_ICON from 'common/icon-mail-default.svg'
import WHATSAPP_ICON from 'common/icon-whatsapp.svg'
import { getRegion } from '@/utils/common'

interface ContactItem {
  link?: string,
  title: string,
  info: string,
  icon: string
}

export default Vue.extend({
  name: 'HeaderContact',
  computed: {
    isRegionMY(): boolean {
      return getRegion()?.region == 'my'
    },
    contactItems(): ContactItem[] {

      return [{
        title: 'Email',
        info: 'customer-service@custa.com',
        icon: EMAIl_ICON
      },
        {
          // TODO: Update phone numbers base on region after meta account business verification is completed
          title: 'Phone/WA',
          link: `https://api.whatsapp.com/send?phone=${this.isRegionMY ? '60162996675' : '6531298111'}`,
          info: this.isRegionMY ? '+60 16-299-6675' : '+65 3129-8111',
          icon: WHATSAPP_ICON
        }
      ]
    }
  }
})
